<div
  [ngClass]="{ border: altColour, alt_format: altColour }"
  id="flightleg-container-{{ flightIndex }}"
>
  @if (!isReturn && !isMultiCity) {
    <div class="flight-header" id="flightleg-header-{{ flightIndex }}">
      <span i18n="@@flightLegDepart">Depart</span> -
      {{ flight.outboundFlights[0]?.dateTimeDeparting | sabsDate: 1 }}
    </div>
  }
  @if (isReturn && !isMultiCity) {
    <div class="flight-header return-flight" id="flightleg-header-{{ flightIndex }}">
      <span i18n="@@flightLegReturn">Return</span> -
      {{ flight.inboundFlights[0]?.dateTimeDeparting | sabsDate: 1 }}
    </div>
  }
  @for (leg of legs; track leg; let i = $index; let first = $first; let last = $last) {
    <div class="leg">
      @if (isMultiCity) {
        <div class="flight-header" id="flightleg-header-{{ flightIndex }}-{{ i }}">
          <span i18n="@@flightLegDepart">Depart</span> - {{ leg.dateTimeDeparting | sabsDate: 1 }}
        </div>
      }
      <div class="flex-row-container amenities-leg-container">
        <div class="flight-logo-container">
          <app-image-with-error
            title="{{ flight.source }}"
            logoUrl="{{
              'https://images.sabscorp.com/images/TourOp/svg/' + leg.marketingCarrier + '.svg'
            }}"
            alt="{{ leg.operatingCarrierName }} - {{ leg.marketingCarrier }} {{
              leg.marketingFlightNumber
            }} - {{ flight.source }}"
            class="ie-width-fix"
          >
          </app-image-with-error>
          <strong
            class="flight-carrier"
            id="flight-legs-carrier-{{ isReturn ? 'return' : 'outbound' }}-{{ flightIndex }}-{{
              i
            }}"
          >
            <span i18n="@@flightLegsOperatedBy" class="operated-by-wrapper">Operated By</span
            >{{ leg.operatingCarrierName }} <br />{{ leg.marketingCarrier
            }}{{ leg.marketingFlightNumber }}</strong
          >
        </div>
        <dl class="leg_trip">
          <div class="leg_start_location" [ngClass]="{ alt_colour: altColour }">
            <dt>
              <time id="flightleg-time-{{ flightIndex }}-{{ i }}">
                {{ parseDateToMoment(leg.dateTimeDeparting) | sabsTimePipe: 'timeString' }}
              </time>
            </dt>
            <dd class="flex-column-container">
              <div>
                <strong id="flightleg-originairport-{{ flightIndex }}-{{ i }}"
                  >{{ leg.originAirportName }} ({{ leg.originAirport }})</strong
                >,
                <span id="flightleg-originterminal-{{ flightIndex }}-{{ i }}">
                  <strong i18n="@@flightLegsTerminalDep">Terminal:</strong>&nbsp;
                  <strong>
                    {{
                      (leg.originTerminal ? leg.originTerminal : 'not available') | translate
                    }}</strong
                  >
                </span>
              </div>
              <span id="flightleg-datedeparting-{{ flightIndex }}-{{ i }}">{{
                leg.dateTimeDeparting | sabsDate: 2
              }}</span>
            </dd>
          </div>
          <div class="duration">
            <dd class="sr-only">duration</dd>
            <dt>
              <time id="flightleg-duration-{{ flightIndex }}-{{ i }}">
                {{ leg.totalDuration | sabsTimePipe: 'min_duration' }}
              </time>
            </dt>
            <dd>
              &nbsp;
              @if (leg.equipmentCode === FlightEquipment.Bus) {
                <section (mouseleave)="tt1.close()">
                  <i
                    style="font-size: 1.5rem"
                    class="ico-bus"
                    i18n-ngbTooltip
                    ngbTooltip="This leg is operated by a Bus."
                    attr.aria-label="This leg is operated by a Bus."
                    triggers="manual"
                    #tt1="ngbTooltip"
                    (mouseenter)="tt1.open()"
                    (focus)="tt1.open()"
                    (blur)="tt1.close()"
                    tabindex="0"
                  ></i>
                </section>
              }
            </dd>
          </div>
          <div class="leg_end_location" [ngClass]="{ alt_colour: altColour }">
            <dt>
              <time id="flightleg-timearriving-{{ flightIndex }}-{{ i }}">
                {{ parseDateToMoment(leg.dateTimeArriving) | sabsTimePipe: 'timeString' }}
                <span class="day-difference"
                  >{{ calculateDayDifference(leg.dateTimeDeparting, leg.dateTimeArriving) }}
                </span>
              </time>
            </dt>
            <dd class="flex-column-container">
              <div>
                <strong id="flightleg-destinationairport-{{ flightIndex }}-{{ i }}"
                  >{{ leg.destinationAirportName }} ({{ leg.destinationAirport }})</strong
                >,
                <span id="flightleg-destinationterminal-{{ flightIndex }}-{{ i }}">
                  <strong i18n="@@flightLegsTerminalDep">Terminal:</strong>&nbsp;
                  <strong>
                    {{
                      (leg.destinationTerminal ? leg.destinationTerminal : 'not available')
                        | translate
                    }}</strong
                  >
                </span>
              </div>
              <span id="flightleg-timearriving-{{ flightIndex }}-{{ i }}">{{
                leg.dateTimeArriving | sabsDate: 2
              }}</span>
            </dd>
          </div>
          <div class="leg_line" aria-hidden="true">
            <div class="leg_line_line"></div>
          </div>
        </dl>
      </div>
      @if (!last && showTimeDifference(leg.dateTimeArrivingUTC, legs[i + 1].dateTimeDepartingUTC)) {
        <div class="legs_layover" id="flightleg-changes-{{ flightIndex }}-{{ i }}">
          <i class="ico-transfer" aria-hidden="true"></i>
          <em i18n="@@flightLegsChangeAt">Change at</em>
          {{ leg.destinationAirportName }} ({{ leg.destinationAirport }})
          <span>{{ this.timeDifference | sabsTimePipe: 'min_duration' }}</span>
        </div>
      }
    </div>
  }
</div>
